// Zentrale Registrierung aller Wiki-Artikel.
// Vite ?raw-Loader importiert die Markdown-Datei als String ins Bundle.
// Reihenfolge bestimmt Sortierung in Sidebar.

import indexContent from '../../wiki/00-index.md?raw'
import funktionsuebersichtContent from '../../wiki/01-funktionsuebersicht.md?raw'
import freigabenContent from '../../wiki/11-freigaben.md?raw'
import autoHarvestContent from '../../wiki/02-auto-harvest.md?raw'
import promotionContent from '../../wiki/03-promotion.md?raw'
import diffContent from '../../wiki/04-auto-harvest-vs-promotion.md?raw'
import zeitraumFilterContent from '../../wiki/05-zeitraum-filter.md?raw'
import demoModusContent from '../../wiki/06-demo-modus.md?raw'
import cronJobsContent from '../../wiki/07-cron-jobs.md?raw'
import glossarContent from '../../wiki/08-glossar.md?raw'
import asinTargetingContent from '../../wiki/09-asin-targeting.md?raw'
import sicherheitContent from '../../wiki/10-sicherheit.md?raw'
import operatorReconcileContent from '../../wiki/12-operator-reconcile.md?raw'

export interface WikiArticle {
  slug: string
  title: string
  content: string
}

export const WIKI_ARTICLES: WikiArticle[] = [
  { slug: 'index', title: 'Übersicht', content: indexContent },
  { slug: 'funktionsuebersicht', title: 'Funktionsübersicht', content: funktionsuebersichtContent },
  { slug: 'freigaben', title: 'Freigaben (Inbox)', content: freigabenContent },
  { slug: 'auto-harvest', title: 'Auto-Harvest', content: autoHarvestContent },
  { slug: 'promotion', title: 'Promotion', content: promotionContent },
  { slug: 'auto-harvest-vs-promotion', title: 'Auto-Harvest vs. Promotion', content: diffContent },
  { slug: 'zeitraum-filter', title: 'Zeitraum-Filter', content: zeitraumFilterContent },
  { slug: 'demo-modus', title: 'Demo-Modus', content: demoModusContent },
  { slug: 'cron-jobs', title: 'Cron-Jobs', content: cronJobsContent },
  { slug: 'asin-targeting', title: 'ASIN-Targeting', content: asinTargetingContent },
  { slug: 'sicherheit', title: 'Sicherheit', content: sicherheitContent },
  { slug: 'operator-reconcile', title: 'Hängende Leases', content: operatorReconcileContent },
  { slug: 'glossar', title: 'Glossar', content: glossarContent },
]

export function findArticle(slug: string): WikiArticle | undefined {
  if (slug === '' || slug === 'index') return WIKI_ARTICLES[0]
  return WIKI_ARTICLES.find((a) => a.slug === slug)
}

// Build-Datum (gesetzt via Vite-Define in vite.config.ts oder Fallback)
declare const __BUILD_TIME__: string | undefined
export const WIKI_BUILD_TIME: string =
  typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : new Date().toISOString()
